import { CustomRangeModifier } from 'src/reducers/pageSettingsReducer/pageSettingsReducer';

export const setMidnightHour = (range: CustomRangeModifier) => {
  const { from, to } = range;
  from && from.setHours(0, 0, 0, 0);
  to && to.setHours(0, 0, 0, 0);
  return range;
};
